module.exports = __webpack_public_path__ + "static/img/dhgc.8cdc2b8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/goods/CCT001/dhgc.png
// module id = xkP2
// module chunks = 1